import { initializeAccordion } from "./helpers/initialize-accordion";

const Header = () => {
  initializeAccordion(".header", "li.openable", "li.openable a", ".aditional-links__wrapper");
  initializeAccordion(".header", "li.openable", "li.openable div", ".my-account__modal");

  const header = document.querySelector(".header");

  if (!header) return;
  
  const itemsOpenableHeader = [...header.querySelectorAll(".header li.openable")];

  const stopPropagation = (event) => event.stopPropagation();

  const handleClickOutside = (event) => {
    itemsOpenableHeader.forEach((itemOpenableHeader) => {
      const aditionalLinksWrapper = itemOpenableHeader.querySelector(".aditional-links__wrapper");
      const myAccountModal = itemOpenableHeader.querySelector(".my-account__modal");

      const isClickOutsideAditionalLinks = aditionalLinksWrapper && !aditionalLinksWrapper.contains(event.target) && !itemOpenableHeader.contains(event.target);
      const isClickOutsideMyAccount = myAccountModal && !myAccountModal.contains(event.target) && !itemOpenableHeader.contains(event.target);

      if (isClickOutsideAditionalLinks && itemOpenableHeader.classList.contains("opened")) {
        itemOpenableHeader.classList.remove("opened");
      }

      if (isClickOutsideMyAccount && itemOpenableHeader.classList.contains("opened")) {
        itemOpenableHeader.classList.remove("opened");
      }
    });
  };

  if (itemsOpenableHeader.length > 0) {
    itemsOpenableHeader.forEach((itemOpenableHeader) => {
      const aditionalLinksWrapper = itemOpenableHeader.querySelector(".aditional-links__wrapper");
      const myAccountModal = itemOpenableHeader.querySelector(".my-account__modal");
      const cartModal = itemOpenableHeader.querySelector(".cart-modal");

      if (aditionalLinksWrapper) {
        aditionalLinksWrapper.addEventListener("click", stopPropagation);
      }

      if (myAccountModal) {
        myAccountModal.addEventListener("click", stopPropagation);
      }
    });

    document.addEventListener("click", handleClickOutside);
  };
};

export default Header;


